import { render } from "./MarketPane.vue?vue&type=template&id=6fda7e40&scoped=true"
import script from "./MarketPane.vue?vue&type=script&lang=js"
export * from "./MarketPane.vue?vue&type=script&lang=js"

import "./MarketPane.vue?vue&type=style&index=0&id=6fda7e40&scoped=true&lang=css"

import exportComponent from "/Users/beerebeerey/github-classroom/MUICCS/cs340prj-beersilver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fda7e40"]])

export default __exports__